import React from 'react';
import { Box } from '@mui/material';
import { colors } from '../../../theme';

interface BulletListProps {
  items: string[];
  color?: 'slate400' | 'slate600';
}

export const BulletList: React.FC<BulletListProps> = ({ items, color: colorProp = 'slate600' }) => {
  const colorValue = colorProp === 'slate400' ? colors.slate[400] : colors.slate[600];

  return (
    <Box
      component="ul"
      sx={{
        margin: 0,
        paddingLeft: '20px',
        '& li': {
          color: colorValue,
          lineHeight: 1.7,
          marginBottom: '8px',
          '&:last-child': {
            marginBottom: 0,
          },
        },
        '& strong': {
          fontWeight: 700,
        },
      }}
    >
      {items.map((item, index) => (
        <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
      ))}
    </Box>
  );
};
